
import { css } from '@emotion/core'
import { colors } from '../../assets/styles/colors'

export const headerTitle = css`
  margin: 0;
  max-width: 380px;
  font-size: 24px;
`

export const alignTop = css`
  align-items: flex-start;
`

export const backdrop = css`
  width: 100%;
  height: 100%;
  z-index: 20;
`

export const container = css`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  max-width: 410px;
  width: calc(100% - 10px);
  padding: 30px;
  background-color: ${colors.white};
  z-index: 25;
  border-radius: 10px;
  box-sizing: border-box;
`

export const transition = (className, duration) => css`
  &.${className}-enter {
    opacity: 0;
  }
  &.${className}-enter-active {
    transition: opacity ${duration}ms;
  }
  &.${className}-exit-active {
    transition: opacity ${duration}ms;
  }
`

export const closeIcon = css`
  width: 30px;
  min-width: 30px;
  height:30px;
  margin-left: 5px;
  border-radius: var(--small-round-element-radius, 50%);
  font-size: 14px;
  font-weight: bold;
  background-color: ${colors.indigo2};
  color: ${colors.white};
  cursor: pointer;
`

export const preventScroll = css`
  body {
    overflow: hidden;
  }
`
